/**
 * Contact Form Validation and Enhancement
 * Provides client-side validation and improved UX for contact forms
 */

(function() {
  'use strict';

  const form = document.getElementById('contact-form');
  if (!form) return;

  const nameInput = document.getElementById('contact-name');
  const emailInput = document.getElementById('contact-email');
  const phoneInput = document.getElementById('contact-phone');
  const messageTextarea = document.getElementById('contact-message');
  const submitButton = form.querySelector('button[type="submit"]');

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /**
   * Validate email format
   */
  function validateEmail(email) {
    return emailRegex.test(email);
  }

  /**
   * Validate phone format (Swedish phone numbers)
   * Accepts: +46XXXXXXXXX, 0XXXXXXXXX, 07X-XXX XX XX, etc.
   */
  function validatePhone(phone) {
    if (!phone || phone.trim() === '') return true; // Phone is optional
    const cleaned = phone.replace(/\s|-/g, '');
    return /^(\+46|0)[1-9]\d{6,9}$/.test(cleaned);
  }

  /**
   * Show field error
   */
  function showFieldError(field, message) {
    // Remove existing error
    removeFieldError(field);

    // Add error class
    field.classList.add('contact-form__input--error');
    field.setAttribute('aria-invalid', 'true');

    // Create error message element
    const errorElement = document.createElement('span');
    errorElement.className = 'contact-form__field-error';
    errorElement.textContent = message;
    errorElement.setAttribute('role', 'alert');
    
    // Insert error message after field
    field.parentNode.insertBefore(errorElement, field.nextSibling);
  }

  /**
   * Remove field error
   */
  function removeFieldError(field) {
    field.classList.remove('contact-form__input--error');
    field.removeAttribute('aria-invalid');
    
    const errorElement = field.parentNode.querySelector('.contact-form__field-error');
    if (errorElement) {
      errorElement.remove();
    }
  }

  /**
   * Validate single field
   */
  function validateField(field) {
    const value = field.value.trim();

    // Name validation
    if (field === nameInput) {
      if (!value) {
        showFieldError(field, 'Namn är obligatoriskt');
        return false;
      }
      if (value.length < 2) {
        showFieldError(field, 'Namnet måste vara minst 2 tecken');
        return false;
      }
      removeFieldError(field);
      return true;
    }

    // Email validation
    if (field === emailInput) {
      if (!value) {
        showFieldError(field, 'E-post är obligatoriskt');
        return false;
      }
      if (!validateEmail(value)) {
        showFieldError(field, 'Ogiltig e-postadress');
        return false;
      }
      removeFieldError(field);
      return true;
    }

    // Phone validation (optional)
    if (field === phoneInput) {
      if (value && !validatePhone(value)) {
        showFieldError(field, 'Ogiltigt telefonnummer');
        return false;
      }
      removeFieldError(field);
      return true;
    }

    // Message validation
    if (field === messageTextarea) {
      if (!value) {
        showFieldError(field, 'Meddelande är obligatoriskt');
        return false;
      }
      if (value.length < 10) {
        showFieldError(field, 'Meddelandet måste vara minst 10 tecken');
        return false;
      }
      removeFieldError(field);
      return true;
    }

    return true;
  }

  /**
   * Validate entire form
   */
  function validateForm() {
    let isValid = true;

    if (nameInput) isValid = validateField(nameInput) && isValid;
    if (emailInput) isValid = validateField(emailInput) && isValid;
    if (phoneInput && phoneInput.value.trim()) {
      isValid = validateField(phoneInput) && isValid;
    }
    if (messageTextarea) isValid = validateField(messageTextarea) && isValid;

    return isValid;
  }

  /**
   * Handle form submission
   */
  function handleSubmit(e) {
    // Clear previous errors
    [nameInput, emailInput, phoneInput, messageTextarea].forEach(field => {
      if (field) removeFieldError(field);
    });

    // Validate form
    if (!validateForm()) {
      e.preventDefault();
      
      // Focus first invalid field
      const firstError = form.querySelector('.contact-form__input--error, .contact-form__textarea--error');
      if (firstError) {
        firstError.focus();
      }
      
      return false;
    }

    // Disable submit button during submission
    if (submitButton) {
      submitButton.disabled = true;
      const originalText = submitButton.textContent;
      submitButton.textContent = 'Skickar...';
      
      // Re-enable after 5 seconds (fallback if form doesn't submit)
      setTimeout(() => {
        submitButton.disabled = false;
        submitButton.textContent = originalText;
      }, 5000);
    }
  }

  /**
   * Real-time validation on blur
   */
  function setupFieldValidation() {
    [nameInput, emailInput, phoneInput, messageTextarea].forEach(field => {
      if (!field) return;
      
      // Validate on blur
      field.addEventListener('blur', function() {
        validateField(this);
      });

      // Clear error on input
      field.addEventListener('input', function() {
        if (this.classList.contains('contact-form__input--error')) {
          removeFieldError(this);
        }
      });
    });
  }

  // Initialize
  if (form) {
    form.addEventListener('submit', handleSubmit);
    setupFieldValidation();
  }
})();




